<template>
  <section id="main-wrap" class="">
    <div class="how-to-matrix-wrap" v-if="howToMatrixActivated">
      <div class="container">
        <a href="#" v-on:click.stop.prevent="howToMatrixClose" class="modal-close"><i class="fal fa-times"></i></a>
        <div class="title-wrap">
          <h2>Hi, welcome to grapevine matrix.</h2>
          <div class="tabs-select">
            <a href="#" v-on:click.stop.prevent="modalTabSwitch('video')" class="active" data-id="video">Grapevine in a Grape</a>
            <a href="#" v-on:click.stop.prevent="modalTabSwitch('image')" data-id="image">Site Map</a>
          </div>
        </div>
        <div class="tab-wrap">
          <div class="tab" data-tab="video">
            <p>Grapevine is a site filled with ‘<strong>grapes</strong>’ – passages from books of between 100 and 550 words.</p>
            <p>The point of grapevine is to be able to find, remember and re-read that great nugget you discovered last week or last year.</p>
            <p>By reading and adding grapes, you can share passages, stumble upon the best-expressed writing, and, over time, build up your own <strong>notebook of knowledge</strong>.</p>
            <div class="divide"></div>
            <p>To add grapes, rate them, or make grapevines, you’ll need to <a href="/#/account">create an account</a>.</p>
            <div class="divide"></div>
            <p><a href="/#/add">Adding grapes</a> takes <strong>less than a minute</strong>.</p>
            <div class="video-wrap">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/4wv5_Nyc7-g" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
            <p>a) choose a book passage you wish to grape and take a photo of the page(s),</p>
            <p>b) find the relevant book using the Source and/or Author boxes <a href="/#/add">here</a>,</p>
            <p>c) upload the photo(s) – this automatically converts to digital text,</p>
            <p>d) give the grape a title, and an optional short note (recommended for fiction).</p>
            <div class="divide"></div>
            <p>If the page photo is good (flat, sharp &amp; shadowless), the digital text shouldn’t need much correcting, if any.</p>
            <p>The text will convert as one big block, if you wouldn’t mind adding back in the original paragraphs.</p>
            <p>You can also add ‘<strong>reader paragraphs</strong>’ by using the > symbol, to make that long Dostoyevsky-ish passage more readable.</p>
            <div class="divide"></div>
            <p>You can also, for clarity, make occasional <strong>omissions</strong> to the text. Instead of an ellipsis, we mark these with the + symbol.</p>
            <p>Omissions allow you to string together a grape that runs over a few pages, when the writer may have digressed.</p>
            <p>Grapes are all uploaded publicly, so they need to be accurate and, if any omissions have been made, fair to the writer’s meaning.</p>
            <div class="divide"></div>
            <p>Once logged in, you can make ‘<strong>grapevines</strong>’. These are in the left-hand sidebar.</p>
            <p>Grapevines are like playlists, where you gather together grapes under a theme (you can add anyone’s grapes to your vines).</p>
            <p>You can <strong>find other readers</strong> in the right-hand sidebar – you can view their grapes and send them a message. (Press enter to see all readers; find me under ‘grapevine’.)</p>
            <div class="divide"></div>
            <p>At the top of the page, you can find grapes if you search by theme, place, author, etc. We have 1600+ grapes so far.</p>
            <p>Finally, grapes are all shown in preview form: just click on the text to view in full.</p>
            <p>Happy grape picking and grape reading.</p>
          </div>
          <div class="tab" data-tab="image">
            IMAGE HERE
          </div>
        </div>
      </div>
    </div>

    <div id="logo">
      <ul class="aux-links">
        <li class="twitter"><a :href="'https://twitter.com/'" target="_blank" v-on:click="siteShare('twitter')"><i class="fab fa-twitter"></i></a></li>
        <li class="instagram"><a :href="'https://www.facebook.com/'" target="_blank" v-on:click="siteShare('twitter')"><i class="fab fa-instagram"></i></a></li>
      </ul>
      <img src="../assets/img/logo.png" />
      <div class="account">
        <router-link to="/account" class="pure-menu-heading"><i class="fas fa-user"></i></router-link>
      </div>
    </div>
    <div class="vertical-divide"></div>
    <form class="matrix-form pure-form">
      <fieldset>
          <div class="pure-control-group search-term">
            <input id="name" type="text" placeholder="Search Here" v-model="searchTerm" autocomplete="off">
          </div>

          <div class="pure-control-group search-field">
            <select v-model="searchField">
              <option value="All">All</option>
              <option value="Title">Title</option>
              <option value="Director">Director</option>
              <option value="Cast">Cast</option>
              <option value="Year">Year</option>
              <option value="Genre">Genre</option>
              <option value="Plot">Plot</option>
              <option value="RTConsensus">Consensus</option>
              <option value="Language">Language</option>
              <option value="Production">Production</option>
            </select>
          </div>

          <div class="pure-controls">
            <button type="submit" class="pure-button" v-on:click.stop.prevent="doMovieSearch()"><i class="fal fa-search"></i></button>
          </div>
      </fieldset>
    </form>

    <div class="outer-chart-wrap">
      <div class="chart-key-panel">
        <div class="movie-panel-loader" v-if="moviePanelShow && !moviePanelLoaded"><i class="fas fa-circle-notch fa-spin"></i></div>
        <div class="movie-panel" :data-doc-id="movieData.docID" v-if="moviePanelShow" v-bind:class="{ moviePanelLoaded: moviePanelLoaded }">
          <div class="add-to-list-panel list-switch-panel" v-if="showListAdd">
            <ul>
              <li v-for="list in lists" :data-id="list.id" v-on:click="addToList(list.id, list.name)">
                <span class="title">{{list.name}}</span>
              </li>
            </ul>
          </div>
          <div class="title-bar">
            <h3>{{movieData.Title}} <span>({{movieData.Year}})</span></h3>
            <a href="#" class="back-button" v-on:click.stop.prevent="moviePanelHide()"><i class="fal fa-long-arrow-left"></i></a>
          </div>
          <div class="img-wrap">
            <img :src="movieData.Poster" :alt="movieData.Title"  />
          </div>
          <div class="meta-wrap">
            <div class="quality-square">
              <span class="score">{{movieData.Quality}}</span>
              <span>Quality</span>
            </div>
            <div class="quality-square">
              <span class="score">{{movieData.Buzz}}</span>
              <span>Buzz</span>
            </div>
            <div class="director"><span>Directed by</span>: <a href="#" v-on:click.stop.prevent="doMovieSearch(movieData.Director, 'Director')">{{movieData.Director}}</a></div>
            <div class="cast meta-list"><span>Starring</span>:
            <ul>
              <li v-for="cast in movieData.Cast" :data-id="cast" v-on:click="doMovieSearch(cast, 'Cast')">{{cast}}</li>
            </ul>
            </div>
            <div class="genre meta-list">
              <ul>
                <li v-for="genre in movieData.Genre" :data-id="genre" v-on:click="doMovieSearch(genre, 'Genre')">{{genre}}</li>
              </ul>
            </div>
          </div>
          <div class="plot-wrap">{{movieData.Plot}}</div>
          <div class="consensus-wrap">{{movieData.RTConsensus}}</div>
          <button class="pure-button trailer-link" :data-video-id="movieData.videoID" v-on:click.stop.prevent="viewTrailer(movieData.videoID)">View trailer</button>
          <button class="pure-button add-to-list-link" :data-video-id="movieData.videoID" v-on:click.stop.prevent="showListsForAdd(movieData.docID, movieData.Title)">Add to List</button>
        </div>
        <div class="chart-key" v-else>
          <h4 v-if="chartView == 'matrix'">
            <span class="top-ten">Top Ten</span> <span>by</span> <a href="#" v-on:click.stop.prevent="changeTop10('buzz')" data-type="buzz" class="top10-link buzz-top10-link active">Buzz</a> <span>/</span> <a href="#" v-on:click.stop.prevent="changeTop10('quality')" data-type="quality" class="top10-link quality-top10-link">Quality</a></span>
            <a href="#" class="switch-link lists-link" v-on:click.stop.prevent="switchToList()">Lists</a>
          </h4>
          <h4 v-if="chartView == 'list'">
            <span class="current-list-switch" v-on:click.stop.prevent="listSwitch()">{{currentListName}} <i class="fas fa-arrows-alt-v"></i></span>
            <a href="#" class="switch-link matrix-top10-link" v-if="chartView == 'list'" v-on:click.stop.prevent="switchToTop10()">Matrix Top 10</a>
          </h4>
          <ol v-if="top10type === 'buzz'">
            <li v-for="film in top10DataBuzz" :data-id="film.objectID" v-on:click="moviePanelDisplay(film.Title)">
              <img :src="film.Poster" />
              <span class="title">{{film.Title}}</span> <span class="count">{{film.Buzz}}</span>
            </li>
          </ol>
          <ol v-else>
            <li v-for="film in top10DataQuality" :data-id="film.objectID" v-on:click="moviePanelDisplay(film.Title)">
              <img :src="film.Poster" />
              <span class="title">{{film.Title}}</span> <span class="count">{{film.Quality}}</span>
            </li>
          </ol>
          <div class="list-panel" v-if="chartView == 'list'">
            <div class="edit-list pure-button" v-on:click="editList()">Edit List</div>
            <div class="map-list pure-button" v-on:click="mapList()">Map List</div>
            <div class="sort-list" v-on:click="sortList()" :data-sort="currentListSort"><i class="fas fa-arrows-alt-v"></i> {{currentListSort}}</div>
            <ol v-if="listFilms.length > 0">
              <li v-for="film in listFilms" :data-id="film.objectID" v-on:click="moviePanelDisplay(film.Title)">
                <img :src="film.Poster" />
                <span class="title">{{film.Title}}</span> <span v-if="currentListSort == 'buzz'" class="count">{{film.Buzz}}</span><span v-if="currentListSort == 'quality'" class="count">{{film.Quality}}</span>
              </li>
            </ol>
            <p v-else>This list currently contains 0 films.</p>
          </div>
          <div class="list-switch-panel" v-if="showListSwitch">
            <div class="pure-form pure-form-stacked">
              <div class="input-field">
                <input name="new_list" placeholder="New list" id="new_list" type="text" class="validate tooltip" v-model="newListName" autocomplete="off" v-on:keyup.enter="createList">
                <div v-on:click="createList" class="add-list-trigger"><i class="fal fa-plus-circle"></i><i class="fas fa-circle-notch fa-spin"></i></div>
              </div>
            </div>
            <ul>
              <li v-for="list in lists" :data-id="list.id" v-on:click="changeCurrentList(list.id, list.name)">
                <span class="title">{{list.name}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="edit-list-table-wrap" v-if="editListMode">
          <table class="films-table pure-table">
            <thead>
              <tr>
                <th></th>
                <th>Film</th>
                <th>Year</th>
                <th>Genre</th>
                <th>Director</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="film in chartData" :data-id="film.objectID" v-on:click="addFilmToCurrentList(film.objectID, film.Title)">
                <td class="poster"><img :src="film.Poster" /></td>
                <td class="title">{{film.Title}}</td>
                <td class="year">{{film.Year}}</td>
                <td class="genre">{{film.Genre}}</td>
                <td class="director">{{film.Director}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="inner-chart-wrap" v-bind:class="{ editListMode: editListMode }">
          <div class="information-link" v-on:click.stop.prevent="howToMatrix()"><i class="fal fa-info-circle"></i></div>
          <Chart :chartData="chartData" :resultsCount="resultsCount" />
        </div>
      </div>
    </div>

    <div id="video-overlay" v-if="viewingTrailer">
      <div class="container">
        <a href="#" v-on:click.stop.prevent="closeTrailerOverlay" class="modal-close"><i class="fal fa-times"></i></a>
        <div class="video-wrap" v-html="videoIframe"></div>
      </div>
    </div>
  </section>
</template>

<script>
  /* global $, algoliasearch */
  import Chart from './ChartView.vue'
  import firebase from 'firebase'
  import db from './firebaseInit'
  import Request from 'superagent'
  import 'vuejs-noty/dist/vuejs-noty.css'

  export default {
    name: 'home',
    metaInfo: {
      title: 'Grapevine Matrix',
      // override the parent template and just use the above title only
      titleTemplate: null
    },
    data () {
      return {
        currentUserID: null,
        searchTerm: '',
        searchField: 'All',
        chartData: [],
        top10DataBuzz: [],
        top10DataQuality: [],
        selectedListData: [],
        top10type: 'buzz',
        resultsCount: 0,
        searchLimit: 100,
        moviePanelShow: false,
        moviePanelLoaded: false,
        movieData: [],
        viewingTrailer: false,
        chartView: 'matrix',
        lists: [],
        currentFilmID: null,
        currentFilmTitle: null,
        currentListID: null,
        currentListName: null,
        currentListSort: 'buzz',
        newListName: null,
        isAddingList: false,
        listFilms: [],
        listFilmIDs: [],
        showListSwitch: false,
        editListMode: false,
        showListAdd: false,
        howToMatrixActivated: false
      }
    },
    created () {
      let vm = this
      this.getMovies()
      vm.doMovieSearch()
      vm.searchLimit = 500
      
      vm.$eventHub.$on('load-movie-panel', function (title) {
        console.log('load-movie-panel')
        vm.moviePanelDisplay(title)
      })

      vm.getLists(true)
    },
    beforeDestroy () {
      this.$eventHub.$off('load-movie-panel')
    },
    methods: {
      siteShare: function () {

      },
      howToMatrix () {
        this.howToMatrixActivated = true
      },
      howToMatrixClose () {
        this.howToMatrixActivated = false
      },
      modalTabSwitch: function (id) {
        console.log(id)
        $('.how-to-grapevine-wrap').find('.tab').css('display', 'none')
        $('.how-to-grapevine-wrap').find('.tabs-select > a').removeClass('active')
        $('.how-to-grapevine-wrap').find('.tab[data-tab="' + id + '"]').css('display', 'block')
        $('.how-to-grapevine-wrap').find('.tabs-select a[data-id="' + id + '"]').addClass('active')
      },
      switchToList: function () {
        this.chartView = 'list'
        this.showListSwitch = false
      },
      switchToTop10: function () {
        this.chartView = 'matrix'
        this.showListSwitch = false
        this.chartData = this.top10DataBuzz
      },
      listSwitch: function () {
        let vm = this
        if (vm.showListSwitch) {
          vm.showListSwitch = false
        } else {
          vm.showListSwitch = true
        }
      },
      changeCurrentList: function  (id, name) {
        let vm = this
        vm.currentListID = id
        vm.currentListName = name
        vm.listChange()
        vm.showListSwitch = false
      },
      doMovieSearch: function (triggeredSearch, triggeredField) {
        let vm = this
        var searchTerm = vm.searchTerm.toLowerCase()
        var searchField = vm.searchField
        vm.chartData = []
        vm.resultsCount = 0
        if (triggeredSearch) {
          searchTerm = triggeredSearch.toLowerCase()
        }
        if (triggeredField) {
          searchField = triggeredField
        }
        if (!searchField) {
          return
        }
        var client = algoliasearch('EQ4MPZHE99', 'b883b4278df4fd23853990e7ed74551d')
        var index = client.initIndex('movies')
        index.search({
          query: searchTerm,
          hitsPerPage: vm.searchLimit
        }).then(responses => {
          // Response from Algolia:
          // https://www.algolia.com/doc/api-reference/api-methods/search/#response-format
          var results = responses.hits
          console.log('number of results: ' + results.length)
          for (var i = 0; i < results.length; i++) {
            var obj = results[i]
            if (searchField === 'All' || ( searchField === 'Year' && obj[searchField] == searchTerm ) || ( searchField !== 'Year' && obj[searchField] && obj[searchField].toLowerCase().indexOf(searchTerm) >= 0 ) ) {
              if (!obj.Poster && obj.PosterPath) {
                obj.Poster = 'https://image.tmdb.org/t/p/w342/' + obj.PosterPath.replace(/ /g, "")
              }
              vm.chartData.push(obj)
              vm.setTop10()
              vm.resultsCount++;
            }
          }
        })
      },
      setTop10: function () {
        let vm = this

        // Set buzz
        vm.top10DataBuzz = vm.chartData
        vm.dataSort(vm.top10DataBuzz, 'Buzz')
        vm.top10DataBuzz = vm.top10DataBuzz.slice(0, 10)

        // Set quality
        vm.top10DataQuality = vm.chartData
        vm.dataSort(vm.top10DataQuality, 'Quality')
        vm.top10DataQuality = vm.top10DataQuality.slice(0, 10)
      },
      dataSort: function (array, field) {
        let vm = this
        array.sort(function (a, b) {
          var countA = a[field] ? parseFloat(a[field]) : 0
          var countB = b[field] ? parseFloat(b[field]) : 0
          return countB - countA
        })
      },
      changeTop10: function (type) {
        this.top10type = type
        console.log(this.top10type)
        $('.top10-link').removeClass('active')
        $('.top10-link[data-type="' + type + '"]').addClass('active')
      },
      moviePanelDisplay: function (title) {
        let vm = this
        vm.movieData = null
        vm.moviePanelLoaded = false
        vm.moviePanelShow = true
        console.log('showing movie panel')
        vm.movieData = vm.chartData.find( function (element) {
          return element.Title == title
        })
        if (!vm.movieData) {
          vm.movieData = vm.listFilms.find( function (element) {
            return element.Title == title
          })
        }
        if (vm.movieData.Cast) {
        vm.movieData.Cast += ''
        // vm.movieData.Cast = vm.movieData.Cast.replace(/�/g, '..')
        vm.movieData.Cast = vm.movieData.Cast.split(',') 
        }
        if (vm.movieData.Genre) {
        vm.movieData.Genre += ''
        vm.movieData.Genre = vm.movieData.Genre.split(',')
        }
        vm.moviePanelLoaded = true
        const req = Request
        .get('https://api.themoviedb.org/3/movie/' + vm.movieData.imdbID + '/videos?api_key=3e3ce1f6731cc0cfdc3596f411aea03f')
        //.query({ segment_id: vm.segment1aday })
        .then(function(res) {
          var data = JSON.parse(res.text)
          console.log(data)
          if (data.results[0]) {
            vm.movieData.videoID = data.results[0].key
            console.log(vm.movieData.videoID)            
          }
        })
        // var moviesRef = db.collection('movies').where('Title', '==', title).get().then((querySnapshot) => {
        //   querySnapshot.forEach((doc) => {
        //     console.log(doc.id, ' => ', doc.data())
        //     vm.movieData = doc.data()
        //     vm.movieData.docID = doc.id
        //     vm.moviePanelLoaded = true
        //   })
        // })
      },
      moviePanelHide: function () {
        let vm = this
        vm.movieData = []
        vm.moviePanelShow = false
      },
      viewTrailer: function (videoID) {
        this.videoIframe = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoID + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
        this.viewingTrailer = true
      },
      closeTrailerOverlay: function () {
        this.viewingTrailer = false
        $('#video-overlay').find('.video-wrap').empty()
      },
      getMovies: function () {
        let vm = this
        var moviesRef = db.collection('movies')
        var titles = []
        moviesRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var movieData = doc.data()
            movieData.docID = doc.id
            // if (titles.includes(movieData.Title)) {
            //   console.log('duplicate found: ' + movieData.Title)
            //   // var movieRef = db.collection('movies').doc(doc.id)
            //   // movieRef.delete().then(function () {
            //   //   console.log('Document successfully deleted!')
            //   // }).catch(function (error) {
            //   //   console.error('Error removing document: ', error)
            //   // })
            // } else {
            //   titles.push(movieData.Title)  
            // }
            vm.indexAlgolia(movieData)
          })
        })
      },
      getListFilms: function () {
        let vm = this
        vm.listFilmIDs.forEach(filmID => {
          var filmRef = db.collection('movies').doc(filmID)
          filmRef.get().then(function (doc) {
            if (doc.exists) {
              var movieData = doc.data()
              movieData.docID = doc.id
              movieData.remove = '<a href="#" data-id="' + doc.id + '" class="remove-film">Remove</a>'
              if (!vm.checkPresentInArray(vm.listFilms, movieData.docID, true)) {          
                vm.listFilms.push(movieData)
              }
            }
          })
        })
      },
      listChange: function () {
        let vm = this
        console.log('list changed: ' + vm.currentListID)
        vm.listFilms = []
        vm.listFilmIDs = []
        // vm.$refs.filmsTable.table.loadData(vm.films)
        var listRef = db.collection('lists').doc(vm.currentListID)
        listRef.get().then(function (doc) {
          console.log(doc.id, ' => ', doc.data())
          vm.listFilmIDs = doc.data().films
          vm.getListFilms()
        })
      },
      getLists: function (withChange) {
        let vm = this
        var listsRef = db.collection('lists')
        listsRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var listData = doc.data()
            listData.id = doc.id
            listData.docID = doc.id
            if (!vm.checkPresentInArray(vm.lists, listData.id, true)) {          
              vm.lists.push(listData)
            }
          })
          if (withChange) {
            setTimeout(function () {
              vm.currentListID = vm.lists[0].id
              vm.currentListName = vm.lists[0].name
              vm.listChange()
            }, 1000)
          }
        })
      },
      checkPresentInArray: function (inArr, ID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].docID === ID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      indexAlgolia: function (movieData) {
        if (location.protocol === 'https:') {
          var client = algoliasearch('EQ4MPZHE99', 'd580a429ccc6fc50a82609fbf4d8b55e')
          var index = client.initIndex('movies')
          if (movieData.docID) {
            console.log('indexing ' + movieData.docID)
            var movieObject = movieData
            movieObject.objectID = movieData.docID
            index.addObjects([movieObject])
          } else {
            console.log('failed to index ' + movieData)
          }
        }
      },
      createList: function () {
        let vm = this
        if (this.newListName && this.newListName.length < 3) {
          return
        }
        if (!vm.isAddingList && this.newListName.length >= 3) {
          vm.isAddingList = true
          let listName = this.newListName
          let userID = this.currentUserID
          $('#new_list').prop('disabled', true)
          $('.add-list-trigger').addClass('is-adding')
          let listData = {
            'name': listName,
            'userID': userID,
            'films': [],
            'createdTimestamp': firebase.firestore.FieldValue.serverTimestamp()
          }
          mixpanel.track(
            'Created list',
            {
              'listName': listName
            }
          )
          db.collection('lists').add(listData).then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
            vm.getLists(false)
            vm.listFilms = []
            vm.listFilmIDs = []
            vm.currentListID = docRef.id
            vm.currentListName = listName
            vm.newListName = ''
            vm.showListSwitch = false
            setTimeout(function () {
              vm.isAddingList = false
              $('#new_list').prop('disabled', false)
              $('.add-list-trigger').removeClass('is-adding')
            }, 500)
          })
        }
      },
      editList: function () {
        if (this.editListMode) {
          this.editListMode = false
        } else {
          this.editListMode = true
        }
      },
      sortList: function () {
        if (this.currentListSort == 'buzz') {
          this.dataSort(this.listFilms, 'Quality')
          this.currentListSort = 'quality'
        } else {
          this.dataSort(this.listFilms, 'Buzz')
          this.currentListSort = 'buzz'
        }
      },
      mapList: function () {
        let vm = this
        vm.chartData = []
        console.log(vm.listFilms)
        vm.chartData = vm.listFilms
      },
      showListsForAdd: function (filmID, filmTitle) {
        console.log('show list add')
        if (this.showListAdd) {
          this.showListAdd = false
        } else {
          this.showListAdd = true
          this.currentFilmID = filmID
          this.currentFilmTitle = filmTitle
        }
      },
      addToList: function (listID) {
        let vm = this
        let filmID = vm.currentFilmID
        let listRef = db.collection('lists').doc(listID)
        listRef.get().then(function (doc) {
          if (doc.exists) {
            var films = doc.data().films
            if ($.inArray(filmID, films) === -1) {
              films.push(filmID)
              listRef.update({
                films: films
              })
              vm.listFilmIDs = films
              vm.getListFilms()
            }
            vm.showListAdd = false
            vm.$noty.success(vm.currentFilmTitle + ' added to list')
            $('.add-to-list-link').text('Added')
            setTimeout(function () {
              $('.add-to-list-link').text('Add to List')
            }, 3000)
          }
        })
      },
      addFilmToCurrentList: function (filmID, filmTitle) {
        let vm = this
        let listRef = db.collection('lists').doc(vm.currentListID)
        listRef.get().then(function (doc) {
          if (doc.exists) {
            var films = doc.data().films
            console.log(films)
            console.log(filmID)
            if ($.inArray(filmID, films) === -1) {
              films.push(filmID)
              listRef.update({
                films: films
              })
              vm.listFilmIDs = films
              vm.getListFilms()
              vm.$noty.success(filmTitle + ' added to list')
            }
          }
        })
      },
    },
    components: {
      Chart
    }
  };
</script>
<style>
  .noty_theme__metroui.noty_type__success {
    background-color: #627F8B;
  }
  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  @-webkit-keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .fadeIn {
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
  }

  @-webkit-keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }

  .fadeOut {
    -webkit-animation-name: fadeOut;
    animation-name: fadeOut;
  }

  .video-wrap iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%!important;
    height: 100%!important;
  }
</style>
<style scoped>
  #main-wrap {
    min-height: 100vh;
    padding-top: 10px;
    width: 1366px;
    margin: 0 auto;
    padding: 0 30px;
    box-sizing: border-box;
    font-family: 'PT Sans', sans-serif;
    color: #627F8B;
  }
  #logo {
    width: 358px;
    height: 108px;
    float: left;
    border-bottom: 1px solid #eaeaea;
    text-align: left;
    padding-top: 20px;
    box-sizing: border-box;
    text-align: center;
    position: relative;
  }
  .aux-links {
    list-style: none;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
    padding: 0;
  }
  .aux-links li {
    margin-top: 5px;
  }
  .aux-links li:first-child {
    margin-top: 0;
  }
  .aux-links li a {
    color: #627F8B;
  }
  #logo .account {
    list-style: none;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
    padding: 0;
    font-size: 1.4em;
  }
  #logo img {
    max-width: 100%;
    height: 75px;
    margin: 0 auto;
    display: inline-block;
  }
  .vertical-divide {
    height: 75px;
    width: 1px;
    float: left;
    background: #eaeaea;
    margin: 20px 22px;
    box-sizing: border-box;
  }
  .matrix-form {
    float: right;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    max-width: 902px;
    padding: 20px 0 12px;
    margin-bottom: 12px;
    box-sizing: border-box;
    width: 100%;
  }
  .matrix-form fieldset {
    padding: 0;
  }
  .pure-form .pure-control-group.search-term {
    width: 60%;
    float: left;
    padding-right: 10px;
    box-sizing: border-box;
  }
  .pure-form .pure-control-group.search-term input {
    height: 75px;
    background: #F9F9F9;
    border: none;
    border-radius: 0;
    padding: 0 30px;
    font-size: 1.8em;
    font-weight: bold;
    box-shadow: none;
  }
  .pure-form .pure-control-group.search-field {
    width: 30%;
    width: calc(40% - 85px);
    float: left;
  }
  .pure-form .pure-control-group.search-field select {
    height: 75px;
    background: #F9F9F9;
    border: none;
    border-radius: 0;
    padding: 0 30px;
    font-size: 1.2em;
    font-weight: bold;
    box-shadow: none;
    -webkit-appearance: none;
    background-image:
      linear-gradient(45deg, transparent 50%, gray 50%),
      linear-gradient(135deg, gray 50%, transparent 50%);
    background-position:
      calc(100% - 30px) calc(2em - 3px),
      calc(100% - 20px) calc(2em - 3px),
      calc(100% - 2.5em) 0.5em;
    background-size:
      13px 8px,
      13px 8px,
      1px 3em;
    background-repeat: no-repeat;
  }
  .pure-form .pure-control-group.search-field select:focus {
    background-image:
      linear-gradient(45deg, #627F8B 50%, transparent 50%),
      linear-gradient(135deg, transparent 50%, #627F8B 50%);
    background-position:
      calc(100% - 20px) calc(2em - 3px),
      calc(100% - 30px) calc(2em - 3px),
      calc(100% - 2.5em) 0.5em;
    background-size:
      13px 8px,
      12px 8px,
      1px 3em;
    background-repeat: no-repeat;
    outline: 0;
  }
  .pure-form .pure-control-group.search-field select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }
  .pure-form .pure-control-group label {
    display: block;
    font-weight: bold;
    text-align: left;
  }
  .pure-form input[type="text"], .pure-form select {
    width: 100%;
  }
  .pure-form .pure-controls {
    float: right;
    margin-top: 0;
    padding-left: 10px;
    width: 75px;
    height: 75px;
  }
  .pure-form .pure-controls button {
    width: 100%;
    height: 100%;
    font-size: 1.6em;
    text-align: center;
    padding: 0;
    background-color: #F9F9F9;
    color: #627F8B;
  }
  .pure-form .pure-controls button > i {
    vertical-align: -1px;
  }
  .outer-chart-wrap {
    width: 100%;
    height: auto;
    overflow: hidden;
    padding-top: 6px;
    position: relative;
  }
  .outer-chart-wrap .chart-key {
    float: left;
    width: 358px;
    text-align: left;
    margin-top: 5px;
    position: relative;
  }
  .outer-chart-wrap .chart-key h4 {
    margin-top: 0;
    padding-bottom: 4px;
    line-height: 37px;
    font-size: 1.4em;
    border-bottom: 1px solid #eaeaea;
    font-weight: normal;
    margin-bottom: 40px;
    position: relative;
  }
  .outer-chart-wrap .chart-key h4 .switch-link {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 0.7em;
  }
  .outer-chart-wrap .chart-key .list-panel {
    position: absolute;
    top: 60px;
    background: white;
    width: 100%;
    height: 100%;
    height: calc(100% - 60px);
    z-index: 2;
  }
  .outer-chart-wrap .chart-key .list-panel .edit-list {
    margin-top: -8px;
    margin-bottom: 10px;
    cursor: pointer;
    float: left;
    padding: .5em 2em;
    background: #627F8B;
    color: #fff;
  }
  .outer-chart-wrap .chart-key .list-panel .map-list {
    margin-top: -8px;
    margin-bottom: 10px;
    margin-left: 10px;
    cursor: pointer;
    float: left;
    padding: .5em 2em;
    background: #296486;
    color: #fff;
  }
  .outer-chart-wrap .chart-key .list-panel .edit-list i {
    margin-right: 3px;
    font-size: 0.8em;    
    vertical-align: 1px;
  }
  .outer-chart-wrap .chart-key .list-panel .sort-list {
    float: right;
    margin-top: -8px;
    margin-bottom: 10px;
    padding: 0.5em 0;
    cursor: pointer;
    text-transform: capitalize;
  }
  .outer-chart-wrap .chart-key .list-panel .sort-list i {
    margin-right: 3px;
    font-size: 0.8em;
    vertical-align: 1px;
  }
  .outer-chart-wrap .chart-key .list-panel > p {
    clear: both;
    margin: 0;
    padding: 20px 0 0;
  }
  .outer-chart-wrap .list-switch-panel {
    position: absolute;
    top: 60px;
    background: #fff;
    border: 1px solid #eaeaea;
    width: 100%;
    z-index: 3;
    padding: 30px;
    box-sizing: border-box;
  }
  .outer-chart-wrap .list-switch-panel > .pure-form {
    border-bottom: 1px solid #eaeaea;
    padding-bottom: 0;
    margin-bottom: 16px;
  }
  .outer-chart-wrap .list-switch-panel ul {
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 355px;
    overflow-y: scroll;
  }
  .outer-chart-wrap .list-switch-panel ul > li {
    cursor: pointer;
    margin: 10px 0;
  }
  .outer-chart-wrap .list-switch-panel ul > li:hover {
    opacity: 0.8;
  }
  .outer-chart-wrap .list-switch-panel .input-field {
    position: relative;
    margin-bottom: 20px;
  }
  .add-list-trigger {
    position: absolute;
    right: 15px;
    top: 50%;
    margin-top: -9px;
    cursor: pointer;
  }
  .add-list-trigger i.fa-circle-notch {
    display: none;
  }
  .add-list-trigger.is-adding i {
    display: none;
  }
  .add-list-trigger.is-adding i.fa-circle-notch {
    display: inline-block;
  }
  .top10-link {
    text-decoration: none;
    color: inherit;
    opacity: 0.4;
  }
  .top10-link.active, .top10-link:hover {
    font-weight: bold;
    opacity: 1;
  }
  .outer-chart-wrap .chart-key h4 span {
    opacity: 0.4;
  }
  .outer-chart-wrap .chart-key h4 span.top-ten, .outer-chart-wrap .chart-key h4 span.current-list-switch {
    font-weight: bold;
    opacity: 1;
  }
  .current-list-switch {
    cursor: pointer;
  }
  .current-list-switch i {
    margin-left: 5px;
    vertical-align: -1px;
    font-size: 0.8em;
  }
  .outer-chart-wrap .chart-key ol {
    padding: 0;
    list-style-position: inside;
    max-height: 474px;
    overflow-y: scroll;
    margin: 0;
    clear: both;
  }
  .outer-chart-wrap .chart-key ol li {
    font-size: 1.15em;
    padding: 8px 10px 8px 60px;
    position: relative;
    cursor: pointer;
    position: relative;
    line-height: 42px;
    height: 44px;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .outer-chart-wrap .chart-key ol li:hover {
    opacity: 0.6;
  }
  .outer-chart-wrap .chart-key ol li span.title {
    font-weight: bold;
    padding-right: 50px;
    box-sizing: border-box;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 85%;
    vertical-align: middle;
    margin-top: -4px;
  }
  .outer-chart-wrap .chart-key ol li span.count {
    font-weight: normal;
    position: absolute;
    right: 10px;
    padding-right: 0;
    top: 7px;
  }
  .outer-chart-wrap .chart-key ol li img {
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
  }
  .outer-chart-wrap .movie-panel {
    float: left;
    width: 358px;
    text-align: left;
    margin-top: 5px;
    opacity: 0;
    position: relative;
  }
  .outer-chart-wrap .movie-panel.moviePanelLoaded {
    opacity: 1;
  }
  .movie-panel-loader {
    float: left;
    width: 358px;
    text-align: center;
    padding: 80px 0;
    font-size: 2em;
    position: absolute;
    top: 0;
    left: 0;
  }
  .outer-chart-wrap .movie-panel .list-switch-panel {
    bottom: 60px;
    top: auto;
    text-align: right;
  }
  .movie-panel .title-bar {
    position: relative;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    padding-bottom: 10px;
  }
  .movie-panel .title-bar h3 {
    margin: 0;
    padding-right: 50px;
    font-size: 1.4em;
  }
  .movie-panel .title-bar h3 span {
    font-size: 0.7em;
  }
  .movie-panel .title-bar a {
    position: absolute;
    right: 0;
    top: 0;
    padding: 2px 10px;
    font-size: 1.2em;
    color: #627F8B;
  }
  .movie-panel .img-wrap {
    width: 40%;
    float: left;
  }
  .movie-panel .img-wrap img {
    width: 100%;
    height: auto;
  }
  .movie-panel .meta-wrap {
    width: 55%;
    float: right;
    text-align: center;
  }
  .movie-panel .meta-wrap span {
    text-decoration: underline;
  }
  .movie-panel .quality-square {
    display: inline-block;
    margin: 0 3px 20px;
    text-align: center;
    background: #397EBF;
    color: #fff;
    width: 50px;
    text-align: center;
    padding: 10px;
  }
  .movie-panel .quality-square span {
    text-decoration: none;
    font-size: 0.8em;
    text-transform: uppercase;
  }
  .movie-panel .quality-square span.score {
    display: block;
    line-height: 24px;
    text-align: center;
    font-size: 1.5em;
    font-weight: bold;
    margin: 5px 0;
  }
  .movie-panel .director, .movie-panel .cast, .movie-panel .genre {
    text-align: left;
    margin-bottom: 10px;
    font-size: 0.85em;
  }
  .movie-panel .genre {
    text-align: right;
  }
  .movie-panel .director a {
    text-decoration: none;
    color: inherit;
  }
  .movie-panel .meta-wrap a {
    color: #397EBF;
  }
  .movie-panel .meta-wrap a:hover, .movie-panel .meta-list ul > li:hover {
    opacity: 0.7;
  }
  .movie-panel .meta-list ul {
    display: inline;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .movie-panel .meta-list ul > li {
    display: inline;
    cursor: pointer;
    color: #397EBF;
  }
  .movie-panel .meta-list ul > li:after {
    content: ', ';
  }
  .movie-panel .meta-list ul > li:last-child:after {
    content: '';
  }
  .movie-panel .genre {
    font-style: italic;
  }
  .movie-panel .plot-wrap {
    clear: both;
    padding: 20px 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* number of lines to show */
    line-height: 22px;        /* fallback */
    max-height: 66px;       /* fallback */
  }
  .movie-panel .consensus-wrap {
    margin-top: 14px;
    border-top: 1px solid #eaeaea;
    padding: 14px 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* number of lines to show */
    line-height: 22px;        /* fallback */
    max-height: 66px;       /* fallback */
  }
  .movie-panel .trailer-link {
    width: 49%;
    margin-top: 20px;
    height: 45px;
    line-height: 45px;
    padding: 0 10px;
    background: #627F8B;
    color: #fff;
    font-size: 1.2em;
  }
  .movie-panel .add-to-list-link {
    width: 49%;
    margin-top: 20px;
    height: 45px;
    line-height: 45px;
    padding: 0 10px;
    background: #296486;
    color: #fff;
    font-size: 1.2em;
  }
  .outer-chart-wrap > section {
    float: right;
  }
  .inner-chart-wrap {
    border-left: 1px solid #eaeaea;
    float: right;
    padding-left: 20px;
    width: 925px;
    box-sizing: border-box;
    position: relative;
  }
  .inner-chart-wrap.editListMode {
    display: none;
  }
  .inner-chart-wrap .information-link {
    position: absolute;
    left: 25px;
    top: 2px;
    font-size: 2em;
    cursor: pointer;
  }
  .edit-list-table-wrap {
    border-left: 1px solid #eaeaea;
    float: right;
    padding-left: 20px;
    width: 925px;
    box-sizing: border-box;
    max-height: 560px;
    overflow-y: scroll;
  }
  .large-film-list {
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: left;
  }
  .large-film-list li {
    width: 100%;
    margin-bottom: 10px;
    font-size: 1.6em;
    cursor: pointer;
  }
  .large-film-list li img {
    width: 80px;
    display: inline-block;
    margin-right: 20px;
  }
  .large-film-list li span {
    display: inline-block;
    line-height: 120px;
    vertical-align: top;
  }
  .films-table {
    border-color: transparent;
  }
  .films-table thead {
    background: transparent;
    font-size: 1.2em;
    color: inherit;
  }
  .films-table tbody tr {
    cursor: pointer;
  }
  .films-table th {
    text-align: left;
    border-width: 0;
    border-bottom: 1px solid #eaeaea;
  }
  .films-table td {
    text-align: left;
    border-color: transparent;
    font-size: 1.2em;
  }
  .films-table td.poster {
    padding: .5em 0 0;
  }
  .films-table td img {
    width: 70px;
  }
  .films-table td.title {
    font-weight: bold;
  }
  .films-table td.director {
    font-size: 1em;
  }
  #video-overlay {
    position: fixed;
    background: rgba(0,0,0,0.8);
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    overflow: hidden;
    padding: 5vh 0;
    bottom: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  #video-overlay > .container {
    width: 1000px;
    max-width: 80%;
    height: auto;
    background: #fff;
    margin: 0 auto;
    padding: 0;
    top: 50%;
    transform: translateY(-50%);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }
  #video-overlay .modal-close {
    position: absolute;
    top: -40px;
    right: -40px;
    width: 38px;
    font-size: 32px;
    color: #fff;
  }
  #video-overlay .modal-close:hover {
    opacity: 0.6;
  }
  .video-wrap {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    padding-top: 25px;
    height: 0;
  }
  .video-wrap:empty {
    display: none;
  }
  .how-to-matrix-wrap {
    position: fixed;
    background: rgba(0,0,0,0.8);
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999;
    overflow-y: scroll;
    padding: 5vh 0;
    bottom: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .how-to-matrix-wrap > .container {
    width: 1000px;
    max-width: 80%;
    height: 90vh;
    background: #fff;
    margin: 0 auto;
    padding: 80px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    overflow-y: scroll;
  }
  .how-to-matrix-wrap .modal-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 38px;
    font-size: 32px;
    color: #222;
  }
  .how-to-matrix-wrap .modal-close:hover {
    opacity: 0.6;
  }
  .how-to-matrix-wrap .title-wrap {
    height: auto;
    overflow: hidden;
    margin: 0 0 40px;
    border-bottom: 1px solid #eaeaea;
    padding-bottom: 20px;
  }
  .how-to-matrix-wrap .title-wrap h2 {
    float: left;
    margin: 0;
    color: #36a731;
    line-height: 40px;
  }
  .how-to-matrix-wrap .title-wrap .tabs-select {
    float: right;
  }
  .how-to-matrix-wrap .title-wrap .tabs-select > a {
    text-decoration: none;
    border: 1px solid #eaeaea;
    padding: 10px 20px;
    margin-left: 10px;
    display: inline-block;
    color: #36a731;
  }
  .how-to-matrix-wrap .title-wrap .tabs-select > a.active {
    background-color: #36a731;
    color: #fff;
  }
  .how-to-matrix-wrap .tab-wrap {
    padding: 0;
  }
  .how-to-matrix-wrap .tab-wrap > .tab {
    display: none;
    text-align: left;
  }
  .how-to-matrix-wrap .tab-wrap > .tab[data-tab="video"] {
    display: block;
    padding-left: 100px;
    padding-right: 100px;
    font-size: 17px;
    line-height: 1.5;
    padding-top: 5px;
  }
  .how-to-matrix-wrap .tab-wrap > .tab .video-wrap {
    margin: 40px 0;
  }
  .how-to-matrix-wrap .tab-wrap > .tab .divide {
    margin: 50px auto;
    width: 75%;
    height: 1px;
    background-color: #eaeaea;
  }
  .how-to-matrix-wrap .tab-wrap > .tab p {
    color: #176B0E;
  }
  .how-to-matrix-wrap .tab-wrap > .tab p a {
    color: #36a731;  
  }
  .how-to-matrix-wrap .tab img {
    width: 100%;
  }
  .tabs-select > a {
    text-transform: uppercase;
  }
</style>


// WEBPACK FOOTER //
// src/components/DataIndex.vue